import { useI18n } from "../i18n";
import { AnimatePresence, motion } from "framer-motion";

const ENTER = { opacity: 0, scale: 1.3, filter: "blur(8px)" };
const SHOW = { opacity: 1, scale: 1, filter: "blur(0px)" };
const LEAVE = { opacity: 0, filter: "blur(6px)" };
const TIMING = { duration: 0.35 };

export const WordDisplay = ({ word, active }) => {
  const { t } = useI18n();
  return (
  <div className="panel relative h-40 flex flex-col items-center justify-center overflow-hidden" data-testid="word-panel">
    <span className="label absolute top-4 left-5">{t("detected")}</span>
    <AnimatePresence mode="wait">
      {word ? (
        <motion.div
          key={word.time + word.word}
          initial={ENTER}
          animate={SHOW}
          exit={LEAVE}
          transition={TIMING}
          className="font-mono font-black tracking-widest text-3xl sm:text-5xl text-amber glow-amber text-center px-4"
          data-testid="ghost-detected-word"
        >
          {word.word}
        </motion.div>
      ) : (
        <span className="font-mono text-subtle tracking-widest text-sm" data-testid="ghost-detected-word-empty">
          {active ? t("listening") : t("noSignal")}
        </span>
      )}
    </AnimatePresence>
  </div>
  );
};
